/* eslint-ignore */
// @ts-nocheck
import React, { useState, useEffect, useMemo } from 'react';

import { useMediaQuery } from 'react-responsive';

import { FirstAccessProvider } from '../../../../hooks/useFirstAccess';

import LogoUltragaz from '../../../../assets/ultragaz-logo-white.svg';
import Pointer from '../../../../assets/icons/pointer.svg';
import SuccessStep from '../../../../assets/icons/success-step.svg';

import YourIdentification from './YourIdentification';
import PersonalData from './PersonalData';
import PasswordRegistration from './PasswordRegistration';
import Validation from './Validation';
import TheEnd from './TheEnd';
import ModalContent from './ModalContent';

import { TYPE_STEPS } from './enums';

import { stepsProvider } from './stepsProvider';

import {
  Container,
  StepsContainer,
  RegistrationContainer,
  LogoContainer,
  Img,
  StepsItems,
  StepItemWrap,
  StepNumberContent,
  StepNumber,
  StepText,
  ItemActive,
  StepsMobileContaimer,
  StepsMobileWrap,
} from './styles';

function NewCadastro() {
  const [activeStep, setActiveStep] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [userId, setUserId] = useState('');
  const [showMobileMode, setShowMobileMode] = useState(true);

  const isMobile = useMediaQuery({ maxWidth: 959 });

  useEffect(() => {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    setEmail(params.get('email'));
    setToken(params.get('token'));
    setUserId(params.get('user-id'));
  }, []);

  useEffect(() => {
    setShowMobileMode(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (email && token && userId) setActiveStep(TYPE_STEPS.validation);
  }, [email, token, userId]);

  const mobileItemsSteps = useMemo(() => {
    const responseItems = [];

    if (activeStep === 1) {
      responseItems.push(stepsProvider[0]);
      responseItems.push(stepsProvider[1]);
      responseItems.push(stepsProvider[2]);
    }

    if (activeStep >= 2 && stepsProvider.length !== activeStep) {
      responseItems.push(stepsProvider[activeStep - 2]);
      responseItems.push(stepsProvider[activeStep - 1]);
      responseItems.push(stepsProvider[activeStep]);
    }

    if (stepsProvider.length === activeStep) {
      responseItems.push(stepsProvider[activeStep - 1]);
    }

    return responseItems;
  }, [activeStep, stepsProvider]);

  return (
    <FirstAccessProvider>
      <Container>
        {!showMobileMode && (
          <StepsContainer>
            <LogoContainer>
              <Img src={LogoUltragaz} alt="Ultragaz Logotipo" />
            </LogoContainer>
            <StepsItems>
              {stepsProvider.length > 0 &&
                stepsProvider.map((step) => (
                  <StepItemWrap key={step.id} active={step.id === activeStep}>
                    <ItemActive>
                      {step.id === activeStep && (
                        <Img src={Pointer} alt="Passo ativo" />
                      )}
                    </ItemActive>
                    <StepNumberContent activeStep="40px">
                      <StepNumber>
                        {step.id >= activeStep && <>{step.number}</>}
                        {step.id < activeStep && (
                          <Img src={SuccessStep} alt="Passo concluído" />
                        )}
                      </StepNumber>
                    </StepNumberContent>
                    <StepText>{step.description}</StepText>
                  </StepItemWrap>
                ))}
            </StepsItems>
          </StepsContainer>
        )}
        <RegistrationContainer>
          {showMobileMode && (
            <StepsMobileContaimer>
              <StepsMobileWrap>
                {mobileItemsSteps.length > 0 &&
                  mobileItemsSteps.map((step) => (
                    <>
                      <StepItemWrap
                        key={step.id}
                        active={step.id === activeStep}
                      >
                        <StepNumberContent>
                          <StepNumber>
                            {step.id >= activeStep && <>{step.number}</>}
                            {step.id < activeStep && (
                              <Img src={SuccessStep} alt="Passo concluído" />
                            )}
                          </StepNumber>
                        </StepNumberContent>
                        <StepText>{step.description}</StepText>
                      </StepItemWrap>
                    </>
                  ))}
              </StepsMobileWrap>
            </StepsMobileContaimer>
          )}
          {activeStep === TYPE_STEPS.yourIdentification && (
            <YourIdentification
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              setShowModal={setShowModal}
            />
          )}
          {activeStep === TYPE_STEPS.personalData && (
            <PersonalData
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          )}
          {activeStep === TYPE_STEPS.passwordRegistration && (
            <PasswordRegistration
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          )}
          {activeStep === TYPE_STEPS.validation && (
            <Validation
              email={email}
              token={token}
              userId={userId}
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          )}
          {activeStep === TYPE_STEPS.theEnd && (
            <TheEnd activeStep={activeStep} setActiveStep={setActiveStep} />
          )}
        </RegistrationContainer>
        <ModalContent isOpen={showModal} setShowModal={setShowModal} />
      </Container>
    </FirstAccessProvider>
  );
}

export default NewCadastro;
